import React from 'react';
import { useState,useEffect } from 'react';
import { Helmet } from 'react-helmet';
import WOW from 'wowjs';

// import AnimatedButton from './layouts/AnimateButton';
import BannerSlider from './animation/BannerSlider';
import TestimonialSlider from './animation/TestimonialSlider';
import BrandSlider from './animation/BrandSlider';
import Program from './section/Program';
import SuccessSlider from './section/SuccessSlider';
// import Stories from './animation/Stories';
// import { Link } from 'react-router-dom';
import CounterSection from './animation/CounterSection';



 function Home(){
    // const handleClick = () => {
    //     window.scrollTo(200, 0);
    //   } 
// readmore readless functionalty
    const [expandedSections, setExpandedSections] = useState({
        aboutProgram: false,
        enhancingEmployability: false,
        skillEnhancement: false,
        higherEducation: false,
        hospitality: false,
        others: false
      });
    // Function to toggle section expansion
    const toggleSection = (sectionKey) => {
      setExpandedSections(prev => ({
        ...prev,
        [sectionKey]: !prev[sectionKey]
      }));
    };
    
    // Function to truncate text
    const truncateText = (text, maxLength) => {
      if (text.length <= maxLength) return text;
      return text.slice(0, maxLength) + '...';
    };
    useEffect(() => {
        // Initialize WOW.js
        new WOW.WOW({
          live: false
        }).init();
      }, []);
    
    return(
    <>
            <Helmet>
        <title>Home  | Joining Hands</title>
      </Helmet>

    <main>
        {/* <!-- Banner area start here --> */}
        <BannerSlider/>

        {/* <!-- Banner area end here -->/ */}
        {/* <!-- Service area start here --> */}
        <section className="service-area pt-100 pb-100 sub-bg">
        
        <Program/>
        </section>
        {/* <!-- Service area end here --> */}

        {/* <!-- About area start here --> */}
        <section className="about-area pt-120 pb-120 ">
            <div className="container">
                <div className="row g-2 align-items-center">
                <div class="col-lg-6 wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
                            <div className="about-two__image image pr-60">
                                <img src="/images/about/about.jpg" alt="about"/>
                                {/* <div class="line-shape sway_Y__animation">
                                    <img src="/images/shape/about-line.png" alt="shape"/>
                                </div> */}
                                <div class="dot-shape sway__animation">
                                    <img src="/images/shape/about-dot3.png" alt="shape"/>
                                </div>
                            </div>
                        </div>
                    <div className="col-lg-6">
                            <div className="section-header mb-20">
                                <h5 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                                    <i className="fa-regular fa-angles-left pe-1"></i> ABOUT US <i
                                        className="fa-regular fa-angles-right ps-1"></i>
                                </h5>
                                <h2 className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">Joining Hands</h2>
                                <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">Joining hands is a non-profit organization working towards enhancing employability of the underprivileged youth through skill development and scholarship for higher education. All efforts are in the direction of empowering the youth such that they find gainful employment and become financially sustainable thereby becoming positively contributing members of not only national GDP in particular but society at large.
                                </p>
                            </div>
                            <div className="about-two__content">
                                <div className="item mb-30 wow fadeInDown" data-wow-delay="00ms" data-wow-duration="1500ms">
                                    <div className="icon service__item first">
                                        <img src="/images/icon/mission-icon1.png" alt="icon"/>
                                    </div>
                                    <div className="content">
                                        <h6 className="mb-10">Vision</h6>
                                        <p> To socially and economically empower the youth who act as agents of change in creating a more equitable world.
                                        </p>
                                    </div>
                                </div>
                                <div className="item wow fadeInDown" data-wow-delay="200ms" data-wow-duration="1500ms">
                                    <div className="icon service__item">
                                        <img src="/images/icon/mission-icon2.png" alt="icon"/>
                                    </div>
                                    <div className="content">
                                        <h6 className="mb-10">Mission</h6>
                                        <p>Skill development & enhancing employability by providing education, training and developing skills of urban poor youth.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </section>
        {/* <!-- About area end here --> */}

      
        {/* <!-- Video area end here --> */}

        {/* <!-- Cause area start here --> */}
        {/* <section className="cause-area pb-120 pt-120 shadow sub-bg">
            <div className="container">
                <div className="section-header mb-60 text-center">
                    <h5 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <i className="fa-regular fa-angles-left pe-1"></i> Features CAUSES <i
                            className="fa-regular fa-angles-right ps-1"></i>
                    </h5>
                    <h3 className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">COVID 19 vaccination drive undertaken for the beneficiaries in May 2021 
                    </h3>
                </div>
                <div className="row g-4">
                    <div className="col-xl-4 col-md-6 wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div className="">
                            <div className="cause__image image">
                                <img src="/images/cause/cause-1.jpg" alt="cause"/>
                            </div>
                           
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
                        <div className="">
                            <div className="cause__image image">
                                <img src="/images/cause/cause-2.jpg" alt="cause"/>
                            </div>
                           
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6 wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                        <div className="">
                            <div className="cause__image image">
                                <img src="/images/cause/cause-3.jpg" alt="cause"/>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </section> */}
        {/* <!-- Cause area end here --> */}

      
        {/* <SuccessSlider /> */}

      
             {/* mission area start area  */}
             <CounterSection/>

        {/* <!-- Counter area end here --> */}

        {/* <!-- Mission area start here --> */}
        {/* <section className="mission-area bg-image pt-120 pb-120" style={{backgroundImage:"linear-gradient(90deg, rgba(255,255,255,.9) 35%, transparent 100%), url('/images/blog/15311.jpg')"}}> */}
        <section className="mission-area position-relative bg-image pt-120 pb-120" style={{backgroundImage:"linear-gradient(90deg, rgba(255,255,255,.9) 35%, transparent 100%), url('/images/banner/why_choose_us.jpg')"}}>
            <div className="container position-static " >
                <div className="row">
                    <div className="col-xl-7">
                        <div className="section-header mb-30">
                            <h5 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms "   >
                                <i className="fa-regular fa-angles-left pe-1"></i> Why <i
                                    className="fa-regular fa-angles-right ps-1"></i>
                            </h5>
                            <h2 className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">Why Choose Us</h2>
                          <div className="content-wrapper">
                          {expandedSections.aboutProgram ? (
                              <>
                            <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">Hope is something that keeps us all alive! We at Joining Hands understand this and work towards keeping it alive for the socio-economically marginalized youth of the society </p>
                            <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                            Education and skills are the two most powerful tools that unlock the doors not only for a better future but also for the urban poor youth this is often a distant dream. This is where we step in to break the social barriers and facilitate constructive input by way of education at large and skilling in particular unlocking their latent potential. Joining Hands believes that education is one the basic necessities that should reach everyone and hence it is our goal to provide that to students that are facing any hurdle in completing their higher education.
                            </p>
                            <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                            Why? We ask you why not? As the largest democracy with one of the steepest projected economic growth and development curves it is the nation’s youth which is going to fuel the thrust and make this trajectory possible. Our work begins where ‘Right To Education’ stops. We focus on  beneficiaries who are either senior secondary pass out or drop outs. 

                            </p>
                            <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">
                            By providing not only timely career counseling but also helping the students decide their career choices but also facilitating them with  the scholarship and mentoring support. We have reached out directly  to a number of students and through them created a positive impact on their families. Our student’s update and record books are full of stories to be told and retold, of their resilience, hard work,  of their determination, of slums to corporate corridors.

                            </p>
                            <p >
                            By providing not only timely career counseling but also helping the students decide their career choices but also facilitating them with  the scholarship and mentoring support. We have reached out directly  to a number of students and through them created a positive impact on their families. Our student’s update and record books are full of stories to be told and retold, of their resilience, hard work,  of their determination, of slums to corporate corridors.

                            </p>
                            <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn"
                                >
                                  Read Less
                                </button>
                              </>
                          ):(
                            <>
                            <p className="wow fadeInUp" data-wow-delay="400ms" data-wow-duration="1500ms">Hope is something that keeps us all alive! We at Joining Hands understand this and work towards keeping it alive for the socio-economically marginalized youth of the society </p>

                            
                            <p class="mb-2 fw-500 text-justify">
                                  {truncateText("  Education and skills are the two most powerful tools that unlock the doors not only for a better future but also for the urban poor youth this is often a distant dream. This is where we step in to break the social barriers and facilitate constructive input by way of education at large and skilling in particular unlocking their latent potential. Joining Hands believes that education is one the basic necessities that should reach everyone and hence it is our goal to provide that to students that are facing any hurdle in completing their higher education....", 700)}
                                </p>
                                <button 
                                  onClick={() => toggleSection('aboutProgram')}
                                  className="read-more-btn text-indigo-600"
                                >
                                  Read More
                                </button>
                              </>
                            )}
                        </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
             {/* mission area end area  */}
        {/* <!-- Testimonial area start here --> */}
        <BrandSlider/>
       

        {/* <Stories/> */}
        <TestimonialSlider/>
        {/* <!-- Testimonial area end here --> */}

        
        {/* <!-- Blog area end here --> */}

        {/* <!-- Brand area start here --> */}
        
        {/* <!-- Brand area end here --> */}
    </main>
    </>
    );

 }
export default Home;
